import { Server, Response } from 'miragejs';
import store from './store';
import * as Cookies from 'tiny-cookie';
const Blowfish = require('javascript-blowfish');

export function makeServer({ environment = 'development' } = {}) {
	let halfFail = true;
	let server = new Server({
		environment,

		routes() {
			this.namespace = 'api';
			this.timing = 10;

			this.get('/customer/token', async () => {
				let responseToken = require('../api/token/send_token.json');
				return new Response(responseToken.status, {}, responseToken.data);
			});

			this.get('/changechip/init', () => {
				const ResponseEnum = {
					SUCCESS: 1,
					ERROR_TOKEN: 2,
					ERROR_ENRICHED_ZERO: 3,
					ELIGIBLE_ERROR: 4,
					SUCCESS_EXOI: 5,
					CORPORATE_CLIENTE: 6,
					SUCCESS_REQUEST_EMAIL: 7,
				};

				const responses = {
					[ResponseEnum.ERROR_TOKEN]:
						'eyJhbGciOiJIUzI1NiJ9.eyJ0aW1lc3RhbXAiOiIyOTA0MjAyMDA2NTcwMiIsImV4cCI6NjIyMjM4ODE5NzQyMiwiQ09EX0VSUk8iOiItMTAwMSIsIkRFU0NfRVJSTyI6Ik1lbnNhZ2VtIHBhcmEgZXJybyBubyBQcm9maWxlX1NlcnZpY2VfQ29udHJhY3RfR3JvdXBfQmFzaWNfUHJvZmlsZV92MSIsImVucmljaGVkIjoiMCJ9.6fyc8ecKPJqxEZ8xTsf0aM5pVRYU5ENl6oA3ljNlXc0',
					[ResponseEnum.ERROR_ENRICHED_ZERO]:
						'eyJhbGciOiJIUzI1NiJ9.eyJ0aW1lc3RhbXAiOiIyMTA1MjAyMDA0MzAxMyIsImV4cCI6NjIyMjM5MDA4OTQxMywiREVTQ19FUlJPIjoiTWVuc2FnZW0gcGFyYSBlcnJvIG5vIFByb2ZpbGVfU2VydmljZV9Db250cmFjdF9Hcm91cF9CYXNpY19Qcm9maWxlX3YxIiwiZW5yaWNoZWQiOiIwIn0.UDU7ez8w3VYd5kJjJ2eMgU81sMoQHO19jeNaGqIKv9E',
					[ResponseEnum.SUCCESS]:
						'eyJhbGciOiJIUzI1NiJ9.eyJwbGFuRGVzYyI6IlDDs3MtcGFnbyIsImxvZ2luVHlwZSI6IjIiLCJlbnJpY2hlZCI6IjIiLCJzdWJTZWdtZW50IjoiMSIsImRvY3VtZW50IjoidWJYTUlCTnJ5UUo3a1ZLd0hvY1ZWdz09Iiwic2VnbWVudERlc2MiOiJDb25zdW1lciIsInBsYW5OYW1lIjoiVElNIEJsYWNrIEEgNiAwIiwicGxhblR5cGVJZCI6IjIiLCJpbXNpIjoiMTIzNDU2Nzg5NjU0IiwibG9naW4iOiIxMTkxMDAwMDAwMCIsImVtYWlsRW5jcnlwdGVkIjoiWldVNVlUWXhZbVZqTXpSaFlqQTNabVF6TVdaaU16TmlZVFpoWW1ZMk4yVmhNMkZqWkdVNFpHWmhZakkzTkRneVlXVXpaRFUxTm1FM09UZzBNMlkzWldFNUxqUTFaV1kyTjJJeU16bG1aakZsTW1KaE1tRTVZekE0TVM0ME9XVTVOV1UwTldFd09UazVZVGcyTnpVd1lUWTFaVEk1TXpjeVl6Y3laZz09IiwicGxhbkNvZGUiOiJQTE41ODAiLCJpc0JpbGxpbmdQcm9maWxlRW1haWwiOiJmYWxzZSIsImljY0lkIjoiODk1NTA0NDgwMDAwMDE1ODA2ODUiLCJpc0V4T2lDdXN0b21lciI6ImZhbHNlIiwibGluZVR5cGUiOiIxIiwic2VnbWVudCI6IjIiLCJleHAiOjg4MTU1ODg3NDYzLCJlbWFpbCI6InZpbmljaXVzKioqKioqKipAdGltYnJhc2lsLmNvbS5iciIsImN1c3RvbWVyIjoiejJqUTRwV2kvUEdTeHVHMXVRTjg1dz09IiwidGltZXN0YW1wIjoiMjIwODIwMjUwMzMxMDMiLCJleHRyYUluZm8iOiJubHZFYnQxQ2EzOWhjb1BiTlFoWkJVUFJWakdMQWUxVHh2cGZ4TXFaSXZRWmcrSTBJQnM2cXVrblduODNIQklOY3lWZ2VTVUcvNUhZcno1bE1rakRxWmFBNFJJV1lVUzloSytjYlNNK2dqUU11S3l4SlBVeXhHdXpCL1pHVytWWVhTOEpmbkNxR0kzM2NvYzQ1QVhOdnhqTjJQQkpMTlVqL2ZoNUVwdXlRNHFwMFU3a1YvUXFDRmVLRFlqTHdoTEU3aTNCRHg5NlQ2UHMxNWhjcStab0dGOW5EYnMvWElLd2F4UCsrZ2hBc0kzZmZDOTlIbUduM2s1OWxac3lVTFVKIn0.l9p6lIB1EQEYiEWP4qpBIY4L5dXQkhWnbSLB6XCYUaQ',
					[ResponseEnum.SUCCESS_EXOI]:
						'eyJhbGciOiJIUzI1NiJ9.eyJwbGFuTmFtZSI6IlRJTSBQUsOJIFRPUCIsInNlZ21lbnREZXNjIjoiQ29uc3VtZXIiLCJzdWJTZWdtZW50IjoiMSIsInNlZ21lbnQiOiIzIiwiY3VzdG9tZXIiOiJIUVA1OWltdnFlMGwwb0lpUE93TDhRPT0iLCJsb2dpblR5cGUiOiIyIiwidGltZXN0YW1wIjoiMTMwNDIwMjIxMTA0MDQiLCJsaW5lVHlwZSI6IjEiLCJleHAiOjYyMjI0NDk5MDE4NDQsImVucmljaGVkIjoiMiIsImRvY3VtZW50IjoiOW1zYW5IR1VuKzl5LzYrbWsxWlVBQT09IiwiaXNFeE9pQ3VzdG9tZXIiOiJ0cnVlIiwicGxhbkNvZGUiOiJQTDAwMDYxIiwibmFtZSI6IklWQU5JRUwgV0VCRVJTT04gREEgU0lMVkEgTUFDSEFETyIsImxvZ2luIjoiMTM5NzExMjI0MzAiLCJpbXNpIjoiNzI0OTg5ODk4OTg5ODk4IiwicGxhbkRlc2MiOiJQcsOpLVBhZ28ifQ.u_r8sFAjjTL2NEvzOlm3cqVabTh0COG9LTxVTSaYY5c',
					[ResponseEnum.CORPORATE_CLIENTE]:
						'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0aW1lc3RhbXAiOiIzMDEyMjAyMTA1NDc1MCIsImV4cCI6NjIyMjQ0MDg5NzI3MCwiZW5yaWNoZWQiOiIwIiwiQ09EX0VSUk8iOiItNDIyMDEiLCJERVNDX0VSUk8iOiJDbGllbnRlIENvcnBvcmF0aXZvIiwiYWxsb3dSZXRyaWVzIjp0cnVlfQ.tr2dPe1NmO-1EZChZFfy4HR4YUTSxd1h1YyFaog0Qvc',
					[ResponseEnum.ELIGIBLE_ERROR]:
						'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0aW1lc3RhbXAiOiIzMDEyMjAyMTA1NDc1MCIsImV4cCI6NjIyMjQ0MDg5NzI3MCwiZW5yaWNoZWQiOiIwIiwiQ09EX0VSUk8iOiItNTAwMDAiLCJERVNDX0VSUk8iOiJFcnJvIFTDqWNuaWNvIC0gQVBJIEVsZWdpYmlsaWRhZGUiLCJhbGxvd1JldHJpZXMiOmZhbHNlfQ.P18JGzKqxkoUpEVCRTN1_O8gjNRxn5q9b-Q6BrU1yjA',
					[ResponseEnum.SUCCESS_REQUEST_EMAIL]:
						'eyJhbGciOiJIUzI1NiJ9.eyJwbGFuRGVzYyI6IlDDs3MtcGFnbyIsImxvZ2luVHlwZSI6IjIiLCJlbnJpY2hlZCI6IjIiLCJzdWJTZWdtZW50IjoiMSIsImRvY3VtZW50IjoidWJYTUlCTnJ5UUo3a1ZLd0hvY1ZWdz09Iiwic2VnbWVudERlc2MiOiJDb25zdW1lciIsInBsYW5OYW1lIjoiVElNIEJsYWNrIEEgNiAwIiwicGxhblR5cGVJZCI6IjIiLCJpbXNpIjoiMTIzNDU2Nzg5NjU0IiwibG9naW4iOiIxMTkxMDAwMDAwMCIsImVtYWlsRW5jcnlwdGVkIjoiWldVNVlUWXhZbVZqTXpSaFlqQTNabVF6TVdaaU16TmlZVFpoWW1ZMk4yVmhNMkZqWkdVNFpHWmhZakkzTkRneVlXVXpaRFUxTm1FM09UZzBNMlkzWldFNUxqUTFaV1kyTjJJeU16bG1aakZsTW1KaE1tRTVZekE0TVM0ME9XVTVOV1UwTldFd09UazVZVGcyTnpVd1lUWTFaVEk1TXpjeVl6Y3laZz09IiwicGxhbkNvZGUiOiJQTE41ODAiLCJpc0JpbGxpbmdQcm9maWxlRW1haWwiOiJmYWxzZSIsImljY0lkIjoiODk1NTA0NDgwMDAwMDE1ODA2ODUiLCJpc0V4T2lDdXN0b21lciI6ImZhbHNlIiwibGluZVR5cGUiOiIxIiwic2VnbWVudCI6IjIiLCJleHAiOjg4MTU1ODg3NDYzLCJlbWFpbCI6InZpbmljaXVzKioqKioqKipAdGltYnJhc2lsLmNvbS5iciIsImN1c3RvbWVyIjoiejJqUTRwV2kvUEdTeHVHMXVRTjg1dz09IiwidGltZXN0YW1wIjoiMjIwODIwMjUwMzMxMDMiLCJleHRyYUluZm8iOiJubHZFYnQxQ2EzOWhjb1BiTlFoWkJVUFJWakdMQWUxVHh2cGZ4TXFaSXZRWmcrSTBJQnM2cXVrblduODNIQklOY3lWZ2VTVUcvNUhZcno1bE1rakRxWmFBNFJJV1lVUzloSytjYlNNK2dqUU11S3l4SlBVeXhHdXpCL1pHVytWWVhTOEpmbkNxR0kzM2NvYzQ1QVhOdnhqTjJQQkpMTlVqL2ZoNUVwdXlRNHFwMFU3a1YvUXFDRmVLRFlqTHdoTEU3aTNCRHg5NlQ2UHMxNWhjcStab0dGOW5EYnMvWElLd2F4UCsrZ2hBc0kzZmZDOTlIbUduM2s1OWxac3lVTFVKIn0.l9p6lIB1EQEYiEWP4qpBIY4L5dXQkhWnbSLB6XCYUaQ',	
				
				};

				// const responsesBody = {
				//     [ResponseEnum.ERROR_TOKEN]: 'eyJhbGciOiJIUzI1NiJ9.eyJ0aW1lc3RhbXAiOiIyOTA0MjAyMDA2NTcwMiIsImV4cCI6NjIyMjM4ODE5NzQyMiwiQ09EX0VSUk8iOiItMTAwMSIsIkRFU0NfRVJSTyI6Ik1lbnNhZ2VtIHBhcmEgZXJybyBubyBQcm9maWxlX1NlcnZpY2VfQ29udHJhY3RfR3JvdXBfQmFzaWNfUHJvZmlsZV92MSIsImVucmljaGVkIjoiMCJ9.6fyc8ecKPJqxEZ8xTsf0aM5pVRYU5ENl6oA3ljNlXc0',
				//     [ResponseEnum.ERROR_ENRICHED_ZERO]: {
				//         "internalCode":"-42201",
				//         "desc":"Cliente Corporativo",
				//         "tid":"283FBDD8612CDCF35D2CEC42",
				//         "access_key":"OTMRrS4ksgxfFgNpANWXuTq+HEUYFeK+lnWR5fOrq6pRvXcp+ez5sD5TnDt7kNvV",
				//     },
				//     [ResponseEnum.SUCCESS]: {
				//         message: "Success"
				//     }
				// }
				Cookies.set(
					'metadata',
					responses[ResponseEnum.SUCCESS_REQUEST_EMAIL]
				);
				Cookies.set(
					'access_key',
					'WSI4oSEX9HjT8xQC5DVlt3MQoYttErEhlbcB5IKLQMUqgl6IuDRt3kDEV0vptSbB'
				);

				return new Response(200, {
					metadata: responses[ResponseEnum.SUCCESS_REQUEST_EMAIL],
					access_key:
						'WSI4oSEX9HjT8xQC5DVlt3MQoYttErEhlbcB5IKLQMUqgl6IuDRt3kDEV0vptSbB',
				});
			});

			this.get('/changechip/validateCustomerPin', async () => {
				let response = require('../api/token/validate_token.json');
				return new Response(response.status, {}, response.data);
			});

			this.post('/changeBillingProfileEmail', () => {
				if (halfFail) {
					halfFail = false;
					return new Response(
						403,
						{},
						{
							interactionProtocol: '08c2f298cn90',
						}
					);
				}
				halfFail = true;
				return new Response(
					200,
					{},
					{
						interactionProtocol: '08c2f298cn90',
					}
				);
			});

			this.get('/verifyEmail', () => {
				const verifyEmailJson = require('../api/verify-email.json');

				return new Response(
					verifyEmailJson.status_number,
					{
						"email": "mail@mail.com",
						"status": true
					},
					verifyEmailJson[verifyEmailJson.status]
				);
			});

			this.get('/validateCustomer', () => {
				let validateCustomerJson = require('../api/validate-customer.json');
				return new Response(
					validateCustomerJson.status_number,
					{},
					validateCustomerJson[validateCustomerJson.status]
				);
			});

			this.get('/emailEligibility/:msisdn', () => {
				const emailEligibilityJson = require('../api/email-eligibility.json');
				return new Response(
					emailEligibilityJson.status_number,
					{},
					emailEligibilityJson[emailEligibilityJson.status]
				);
			});

			this.get('_staticfiles16/catalogo/js/trocachipconfig', async () => {
				let jsonConfig = require('../api/config.json');

				var bf = new Blowfish.Blowfish('t1mTr0c4Ch1p', 'ecb');
				let encryptedString = bf.encrypt(JSON.stringify(jsonConfig));
				encryptedString = bf.base64Encode(encryptedString);

				return new Response(200, {}, encryptedString);
			});

			this.get('/validateProtocol', () => {
				return new Response(
					200,
					{},
					{
						internalCode: '1',
						desc: 'Sucesso',
						tid: '12CF881D171607B9C067DC5',
					}
					// {
					//     "internalCode": "-40000",
					//     "descErro": "Erro ao enviar solicitação",
					//     "errorDescription": "Por favor, tente novamente mais tarde"
					// }
				);
			});

			this.get('/simCard/reserve', () => {
				return new Response(
					200,
					{},
					{
						url: 'LPA:1$rsp-1011.oberthur.net$CSUBB-UGF8H-HCMVQ-KVLUO',
						simCard: {
							iccid: '89550328000000979230',
						},
					}
				);
			});

			this.get('/order', () => {
				// let errorUnauthorized = {
				// 	internalCode: '-40001',
				// 	desc: 'Para mais informações ligue *144, ou acesso o portal Meu TIM.',
				// 	message: 'Não foi possível realizar a troca do seu chip',
				// };
				// let error = {
				// 	internalCode: '-20000',
				// 	desc: 'Para mais informações ligue *144, ou acesso o portal Meu TIM.',
				// 	message: 'Não foi possível realizar a troca do seu chip',
				// };
				// if (
				// 	store.getters.getBarCode === '12341234123412341234' ||
				// 	store.getters.getBarCode === ''
				// ) {
				return new Response(
						200,
						{},
						// error
						{
							internalCode: '1',
							desc: 'Sucesso',
							protocol: '123456',
						}
				);
				// } else {
				// 	return new Response(
				// 		400,
				// 		{},
				// 		store.getters.getBarCode === '11111111111111111111'
				// 			? errorUnauthorized
				// 			: error
				// 	);
				// }
			});

			this.get('/user/info', () => {
				let json = {
					internalCode: '1',
					desc: 'Sucesso',
					tid: '5E0183015DB74A5B385139AD',
					access_key:
						'WSI4oSEX9HjT8xQC5DVlt3MQoYttErEhlbcB5IKLQMUqgl6IuDRt3kDEV0vptSbB',
					customer: {
						'social-sec-no': '37362515804',
						name: 'DALTON AUGUSTO SOARES',
						birthdate: '09/08/1989 00:00:00',
						sex: 'M',
						address: {
							street: {
								type: 'RUA',
								name: 'ATABASCA',
								number: '363',
							},
							neighborhood: 'JARDIM SANTO ALBERTO',
							city: 'SANTO ANDRE',
							state: 'SP',
							country: 'Brasil',
							zipcode: '09260430',
						},
						reason: 'OK',
						status: 'OK',
					},
				};
				if (store.getters.getMsisdn) {
					return new Response(200, {}, json);
				} else {
					return new Response(
						400,
						{},
						{
							error: '1',
							message: 'User not found',
						}
					);
				}
			});

			this.post('/protocol', (schema, request) => {
				const params = JSON.parse(request.requestBody);
				if (params.protocol === '123456789') {
					return new Response(
						200,
						{},
						{
							internalCode: '1',
							desc: 'Sucesso',
						}
					);
				} else {
					return new Response(
						500,
						{},
						{
							internalCode: '-400',
							desc: 'Protocolo inválido',
							message: 'O numero do protocolo é invalido',
						}
					);
				}
			});

			this.post('/v1/analytics/event', () => {
				return new Response(
					200,
					{},
					{
						internalCode: '1',
						desc: 'Sucesso',
					}
				);
			});

			this.get('/auth-question', (schema, request) => {
				const RESPONSE_SUCCESS = true;
				const RESPONSE_DATA = {
					1: {
						id: 1,
						question: 'Qual é o primeiro nome da sua mãe?',
						options: [
							{ label: 'Carolina', value: 'Carolina' },
							{ label: 'Juliana', value: 'Juliana' },
							{ label: 'Ana Carolina', value: 'Ana Carolina' },
						],
					},
					2: {
						id: 2,
						question: 'Qual é o número de endereço de cobrança da sua fatura?',
						options: [
							{ label: '1.315', value: '1.315' },
							{ label: '205', value: '205' },
							{ label: '701', value: '701' },
						],
					},
					3: {
						id: 3,
						question:
							'Selecione abaixo o número que você mais ligou no último mês?',
						options: [
							{ label: '(11) 11111-1111', value: '(11) 11111-1111' },
							{ label: '(22) 22222-2222', value: '(22) 22222-2222' },
							{ label: '(33) 33333-3333', value: '(33) 33333-3333' },
						],
					},
				};

				if (RESPONSE_SUCCESS) {
					return new Response(
						200,
						{},
						{
							internalCode: '1',
							desc: 'Sucesso',
							data: RESPONSE_DATA[request.queryParams.step],
						}
					);
				} else {
					return new Response(
						500,
						{},
						{
							internalCode: '-400',
							desc: 'Erro a processar pergunta',
							message: 'Não conseguimos carregar suas informações',
						}
					);
				}
			});

			this.post('/auth-question', (schema, request) => {
				const ANSWERS = {
					1: 'Juliana',
					2: '701',
					3: '(11) 11111-1111',
				};
				const params = JSON.parse(request.requestBody);
				if (ANSWERS[params.step] == params.answer) {
					return new Response(
						200,
						{},
						{
							internalCode: '1',
							desc: 'Sucesso',
						}
					);
				} else {
					return new Response(
						500,
						{},
						{
							internalCode: '-400',
							desc: 'Resposta inválida',
							message: 'Você tem apenas mais uma tentativa',
						}
					);
				}
			});

			this.get('/changechip/reinit', () => {
				const SUCCESS_RESPONSE = {
					internalCode: '1',
					desc: 'Sucesso',
				};

				Cookies.set(
					'metadata',
					'eyJhbGciOiJIUzI1NiJ9.eyJwbGFuRGVzYyI6IlBbMHhjM11bMHhiM11zLXBhZ28iLCJsb2dpblR5cGUiOiIyIiwiZW5yaWNoZWQiOiIyIiwic3ViU2VnbWVudCI6IjEiLCJzZWdtZW50RGVzYyI6IkNvbnN1bWVyIiwicGxhbk5hbWUiOiJUSU0gQmxhY2sgQyBMaWdodCAzIDAiLCJpbXNpIjoiMDgxOTExMTEzMDIyNjQwNDAyIiwibG9naW4iOiIxMTkwMDAwMDAwMSIsInBsYW5Db2RlIjoiUExONTU2IiwiaXNFeE9pQ3VzdG9tZXIiOiJ0cnVlIiwibGluZVR5cGUiOiIxIiwic2VnbWVudCI6IjIiLCJleHAiOjg4MDQxOTMyNTI5LCJjdXN0b21lciI6IlZCcUE4cHltUXZIY2E1WUZoeHNaWmc9PSIsInRpbWVzdGFtcCI6IjExMDEyMDIyMDYyMjA5In0.LInohJTBjPrOA_MUxHaS55a_vxnCGRhUwYRyjVfadi0'
				);

				// const ERROR_RESPONSE = {
				//     internalCode: '-42000',
				//     COD_ERRO: "-50000",
				//     DESC_ERRO: "Dados incorretos",
				//     MSG_ERRO: "Certifique-se de que as informações foram digitadas corretamente"
				// };

				return new Response(200, {}, SUCCESS_RESPONSE);

				// if (!request.queryParams.cpf) {
				//     return new Response(200, {}, SUCCESS_RESPONSE);
				// } else {
				//     return new Response(420, {}, ERROR_RESPONSE);
				// }
			});

			this.post('/emailStatus', () => {
				const SUCCESS_RESPONSE = {
					interaction: [
						{
							creationDateTime: '2024-01-08T14:28:59',
							document: {
								number: '21467077046',
								type: 'PF',
							},
							id: '01c52dbe-2183-4f4d-bf80-74f6db7bced2',
							msisdn: '83999010184',
							protocol: '2024000000754',
							reason1: 'Solicitação',
							reason2: 'Conta',
							reason3: 'Alteração de Perfil de Fatura',
							source: 'APP',
							status: 'OPENED',
							updateDateTime: '2024-01-08T14:28:59',
						},
					],
				};

				return new Response(200, {}, SUCCESS_RESPONSE);
			});
		},
	});

	return server;
}